"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifall = ifall;
var _if = require("./if");
function ifall(...args) {
  const options = args.pop();
  if (args.every(arg => (0, _if.ifContextChartProperty)(arg))) return options.fn(this);
  return options.inverse(this);
}